<template>
  <v-dialog v-model="dialog" max-width="720px">
    <v-card class="pa-2">
      <v-card-title>{{ $t("parts.inventory.actions.shareData") }}</v-card-title>
      <v-card-text class="pt-2 pb-4">
        <div class="share-options-grid">
          <button
            type="button"
            class="share-option"
            @click="shareWhatsApp"
          >
            <div class="share-option-icons">
              <v-icon color="green" size="32">mdi-whatsapp</v-icon>
            </div>
            <span class="share-option-label">WhatsApp</span>
          </button>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import config from "../../config";

export default {
  components: {},
  data: () => ({
    dialog: false,
    items: [],
  }),
  computed: {
    getUrl() {
      return this.items
        .map(
          (item) =>
            `${config.getShopUri()}/share/part/${item.part_id._id}`,
        )
        .join("\n");
    },
  },
  methods: {
    shareWhatsApp() {
      this.openWhatsAppShare(this.getUrl);
    },
    openWhatsAppShare(text) {
      const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
      const width = 800;
      const height = 500;
      const left = (window.innerWidth - width) / 2;
      const top = (window.innerHeight - height) / 2;

      window.open(
        url,
        "Share on WhatsApp",
        `width=${width},height=${height},top=${top},left=${left},resizable,scrollbars=yes,status=1`,
      );
    },
    open(data) {
      this.items = data;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.share-options-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
}

.share-option {
  display: flex;
  flex: 1 1 150px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 150px;
  max-width: 200px;
  min-height: 110px;
  padding: 16px 12px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

.share-option:hover {
  background-color: #fafafa;
  border-color: rgba(0, 0, 0, 0.24);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.share-option:focus-visible {
  outline: 2px solid #1976d2;
  outline-offset: 2px;
}

.share-option-icons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 10px;
}

.share-option-label {
  font-size: 14px;
  line-height: 1.35;
  color: rgba(0, 0, 0, 0.87);
  text-align: center;
  word-break: break-word;
}
</style>
